module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "center2"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("ACKNOWLEDGMENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The \"Mark Dalton: Owner Operator\" stories would never have shifted into gear without the encouragement of former "), _c('em', [_vm._v("Truck News")]), _vm._v(" editor John G. Smith who invited me to write a story for the magazine in the summer of 1999; I'd also like to thank former "), _c('em', [_vm._v("Truck News")]), _vm._v(" editors John Curran and Ingrid Phanuef, "), _c('em', [_vm._v("Truck News ")]), _vm._v("executive editor James Menzies, and publisher Rob Wilkins for their continued and enthusiastic support; Also, many of the stories have benefited from the input from people working in the trucking industry. I am especially indebted to the following people for their help: Rob Quentin, former service manager at Brampton Peterbilt; 1996 "), _c('em', [_vm._v("Truck News")]), _vm._v(" Owner/Operator of the Year Dale Holman; dispatcher Marcel Larendeau of Bison Transport; and Dan Simcock of Arnold Brothers Transport.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d5fb67f2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ack.vue
// module id = 72
// module chunks = 0